import { getUrl } from '../data';
import { TrackerType } from './TrackerType';
import debounce from 'debounce';

let buffer = [];
let storedVisitorId = null;

const submitBuffer = debounce((dispatch: AppDispatch) => {
  dispatch(async (_, getState: RootStateGetter) => {
    const visitorId = getState().visitorId.id;

    const submitActions = buffer.map((item) => ({
      objectId: visitorId,
      objectType: 'visitorId',
      action: 'frontend-tracking:' + item.name,
    }));
    buffer = [];

    try {
      // Versuche zuerst sendBeacon, falle auf fetch zurück wenn es nicht funktioniert
      const success = navigator.sendBeacon(getUrl('/api/ens/v1/stats/track/batch'), JSON.stringify(submitActions));
      if (!success) {
        throw new Error('sendBeacon war nicht erfolgreich');
      }
    } catch (e: unknown) {
      fetch(getUrl('/api/ens/v1/stats/track/batch'), {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(submitActions),
        keepalive: true, // Stellt sicher, dass die Anfrage auch nach dem Schließen der Seite abgeschlossen wird
      }).catch((error) => console.error('Fehler beim Senden der Tracking-Daten:', e, error));
    }
  });
}, 1000);

window.addEventListener('beforeunload', () => {
  submitBuffer.flush();
});
window.addEventListener('pagehide', () => {
  submitBuffer.flush();
});

export const LocalPageTracking: TrackerType = (trackingObj, dispatch) => {
  if (!storedVisitorId) {
    dispatch((_, getState: RootStateGetter) => {
      storedVisitorId = getState()?.visitorId?.id;
    });
  }

  buffer.push({ ...trackingObj });
  submitBuffer(dispatch);

  if (trackingObj.__forceFlush) submitBuffer.flush();
};
